import React from 'react';
import Table from './Table';

const CategoryList = () => {
  return (
    <div>
      <Table />
    </div>
  )
}

export default CategoryList